import React from 'react';
import { LuEye, LuHistory } from 'react-icons/lu';

import { NoteView } from '@ndvr/customer-api';

import { MinimalTiptapEditorNoToolbar } from '@/components/minimal-tiptap';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/utils/cn';
import { convertPlainTextToHtml, formatDateTime } from 'utils';

interface RelatedMeetingNotesListProps {
    notes: NoteView[];
    onNoteClick?: (note: NoteView) => void;
    title?: string;
    className?: string;
}

export const RelatedMeetingNotesList = ({
    notes,
    onNoteClick,
    title = 'Meeting Notes',
    className,
}: RelatedMeetingNotesListProps) => {
    if (!notes.length) {
        return null;
    }

    return (
        <div className={cn('space-y-3', className)}>
            <div className="flex items-center gap-2">
                <LuHistory className="text-muted-foreground h-4 w-4" />
                <h4 className="text-sm font-medium">{title}</h4>
            </div>
            <div className="space-y-2">
                {notes.map((note) => (
                    <Card
                        key={note.noteGUID}
                        className="hover:bg-muted/50 cursor-pointer transition-colors"
                        onClick={() => onNoteClick?.(note)}
                    >
                        <CardContent className="p-3">
                            <div className="flex items-start justify-between">
                                <div className="min-w-0 flex-1">
                                    <h5 className="truncate text-sm font-medium">{note.subject ?? ''}</h5>
                                    <div className="text-muted-foreground mt-1 line-clamp-2 text-xs">
                                        <MinimalTiptapEditorNoToolbar
                                            value={convertPlainTextToHtml(note.content.substring(0, 120) || '')}
                                            className="w-full"
                                            editorContentClassName="p-5"
                                            output="html"
                                            editable={false}
                                            editorClassName="focus:outline-hidden"
                                        />
                                    </div>
                                    <div className="mt-2 flex items-center gap-2">
                                        {note.updatedAt && (
                                            <span className="text-muted-foreground text-xs">
                                                {formatDateTime(note.updatedAt)}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <LuEye className="text-muted-foreground h-4 w-4 flex-shrink-0" />
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};
